import { Stack, Table } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { t } from 'i18next';

import { NoContentPlaceholder } from '@/core/components';

import { Id } from '@/feature/utils';

import { getJournalImpactFactorRankOptions } from './model/JournalQuery';

interface JournalImpactFactorRankTableProps {
  journalId: Id;
}

export function JournalImpactFactorRankTable({ journalId }: JournalImpactFactorRankTableProps) {
  const { data: ranks } = useSuspenseQuery(getJournalImpactFactorRankOptions(journalId));

  return (
    <Stack>
      {ranks.length === 0 && <NoContentPlaceholder title={t('journals.reputation.noData')} />}

      {ranks.length != 0 && (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t('journals.reputation.impactFactor.rank.tableHeader.quarterly')}</Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.rank.tableHeader.rank')}</Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.rank.tableHeader.year')}</Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.rank.tableHeader.wosCategory')}</Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.rank.tableHeader.wosIndex')}</Table.Th>
              <Table.Th>{t('journals.reputation.impactFactor.rank.tableHeader.suppressed')}</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {ranks.map(item => (
              <Table.Tr key={item.id}>
                <Table.Td>{item.quarterly}</Table.Td>
                <Table.Td>
                  {item.rank}/{item.rankOf}
                </Table.Td>
                <Table.Td>{item.year}</Table.Td>
                <Table.Td>{item.wosCategory?.name}</Table.Td>
                <Table.Td>{item.wosIndex?.name}</Table.Td>
                <Table.Td>
                  <input
                    type="checkbox"
                    checked={item.suppressed}
                    disabled
                  ></input>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Stack>
  );
}
